@if (project(); as p) {
  <article class="project-detail-page">
    
    <!-- Top Back Navigation Bar -->
    <div class="top-nav-bar">
      <div class="container-wide">
        <a routerLink="/" class="back-link">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          <span>BACK TO PORTFOLIO</span>
        </a>
      </div>
    </div>

    <!-- Project Hero Header -->
    <section class="detail-hero">
      <div class="hero-img-wrap" [style.background-image]="'url(' + selectedGalleryImage() + ')'">
        <div class="hero-overlay"></div>
      </div>

      <div class="container-wide hero-content">
        <div class="category-tag">{{ p.categoryLabel }}</div>
        <h1 class="project-title">{{ p.title || p.location }}</h1>
        
        <div class="project-meta-row">
          @if (p.title && p.location) {
            <div class="meta-item location-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              <span class="location-bold">{{ p.location }}</span>
            </div>
            <div class="meta-divider">•</div>
          }
          <div class="meta-item">
            <span class="label">COMPLETED:</span>
            <span>{{ p.completionYear }}</span>
          </div>
          <div class="meta-divider">•</div>
          <div class="meta-item">
            <span class="label">FOOTPRINT:</span>
            <span>{{ p.size }}</span>
          </div>
        </div>

        <!-- Multi-Dwelling Specs Box for Project Detail Hero -->
        @if (p.dwellings && p.dwellings.length > 0) {
          <div class="hero-dwellings-specs-box">
            @for (dwelling of p.dwellings; track dwelling.name) {
              <div class="hero-dwelling-row">
                @if (p.dwellings.length > 1) {
                  <span class="dwelling-title">{{ dwelling.name }}</span>
                }
                <div class="dwelling-specs-list">
                  @if (dwelling.bedrooms) {
                    <span class="metric-item" title="Bedrooms">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4v16"/><path d="M2 11h20"/><path d="M22 11v9"/><path d="M6 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M14 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M2 17h20"/></svg>
                      <span>{{ dwelling.bedrooms }} Bedroom</span>
                    </span>
                  }
                  @if (dwelling.bathrooms) {
                    <span class="metric-item" title="Bathrooms">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6 6.5 3.5M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-3zM4 12V7a2 2 0 0 1 2-2h3"/></svg>
                      <span>{{ dwelling.bathrooms }} Bathroom</span>
                    </span>
                  }
                  @if (dwelling.garageSpaces) {
                    <span class="metric-item" title="Garage Spaces">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H7.5a1 1 0 0 0-.8.4L4 11l-1.16.86A1 1 0 0 0 2 12.85V16h3"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="17.5" cy="16.5" r="2.5"/></svg>
                      <span>{{ dwelling.garageSpaces }} Garage</span>
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <!-- Quick Specs Row (Bedrooms, Bathrooms, Garage, Land Area, Storey Type) -->
          <div class="hero-quick-specs">
            @if (p.bedrooms) {
              <div class="hero-spec-item" title="Bedrooms">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4v16"/><path d="M2 11h20"/><path d="M22 11v9"/><path d="M6 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M14 11V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4"/><path d="M2 17h20"/></svg>
                <span>{{ p.bedrooms }} Bedroom</span>
              </div>
            }
            @if (p.bathrooms) {
              <div class="hero-spec-item" title="Bathrooms">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6 6.5 3.5M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-3zM4 12V7a2 2 0 0 1 2-2h3"/></svg>
                <span>{{ p.bathrooms }} Bathroom</span>
              </div>
            }
            @if (p.garageSpaces) {
              <div class="hero-spec-item" title="Garage Spaces">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H7.5a1 1 0 0 0-.8.4L4 11l-1.16.86A1 1 0 0 0 2 12.85V16h3"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="17.5" cy="16.5" r="2.5"/></svg>
                <span>{{ p.garageSpaces }} Garage</span>
              </div>
            }
            @if (p.landArea || p.size) {
              <div class="hero-spec-item" title="Land / House Area">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" stroke-dasharray="4 2"/><path d="M9 3v18M15 3v18M3 9h18M3 15h18"/></svg>
                <span>{{ p.landArea || p.size }}</span>
              </div>
            }
            @if (p.storeyType) {
              <div class="hero-spec-item storey-tag">
                <span>{{ p.storeyType }}</span>
              </div>
            }
          </div>
        }
      </div>
    </section>

    <!-- Main Body Container -->
    <div class="container-wide page-body section-padding">
      
      <!-- Video Walkthrough & Media Player Section -->
      @if (p.videoUrl) {
        <section class="video-showcase-section">
          <div class="section-title-wrap">
            <span class="sub-badge">ARCHITECTURAL FILM & WALKTHROUGH</span>
            <h2 class="section-heading">CINEMATIC VIDEO TOUR</h2>
          </div>

          <div class="video-player-container">
            <video 
              #videoPlayer 
              [src]="p.videoUrl" 
              controls 
              [poster]="p.image"
              preload="metadata"
              class="architectural-video">
              Your browser does not support HTML5 video.
            </video>
          </div>
        </section>
      }

      <!-- Project Story & Specs Grid -->
      <div class="story-specs-grid">
        
        <!-- Left: Overview -->
        <div class="story-col">
          <h2 class="col-title">ARCHITECTURAL DESIGN OVERVIEW</h2>
          <div class="gold-divider-left"></div>
          <p class="overview-text">{{ p.fullOverview }}</p>
        </div>

        <!-- Right: Specs Sidebar Card -->
        <div class="specs-sidebar-col">
          <div class="specs-card">
            <h3 class="card-title font-serif">PROJECT SPECIFICATIONS</h3>
            <div class="gold-divider-left"></div>

            <div class="spec-row">
              <span class="lbl">LOCATION</span>
              <span class="val">{{ p.location }}</span>
            </div>
            <div class="spec-row">
              <span class="lbl">BUILD TYPE</span>
              <span class="val">{{ p.categoryLabel }}</span>
            </div>
            <div class="spec-row">
              <span class="lbl">CONSTRUCTION TIME</span>
              <span class="val">{{ p.buildTime }}</span>
            </div>
            <div class="spec-row">
              <span class="lbl">TOTAL AREA</span>
              <span class="val">{{ p.size }}</span>
            </div>
            <div class="spec-row">
              <span class="lbl">ARCHITECT & BUILDER</span>
              <span class="val">{{ p.architect }}</span>
            </div>

            <!-- Materials Palette -->
            @if (p.materials && p.materials.length > 0) {
              <div class="materials-block">
                <span class="mat-title">SIGNATURE MATERIALS PALETTE</span>
                <div class="mat-tags">
                  @for (mat of p.materials; track mat) {
                    <span class="mat-tag">{{ mat }}</span>
                  }
                </div>
              </div>
            }

            <button (click)="requestConsultationForProject()" class="btn-gold sidebar-cta">
              ENQUIRE ABOUT A SIMILAR PROJECT
            </button>
          </div>
        </div>

      </div>

      <!-- Key Features Checklist (Full Width Section) -->
      @if (p.features && p.features.length > 0) {
        <div class="features-block full-width-inclusions">
          <h3 class="block-title">KEY INCLUSIONS</h3>
          <div class="features-grid">
            @for (feat of p.features; track feat) {
              <div class="feature-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                <span [innerHTML]="feat"></span>
              </div>
            }
          </div>
        </div>
      }

      <!-- High-Res Photo Gallery Section -->
      <section class="gallery-section">
        <div class="gallery-header-row">
          <div class="section-title-wrap">
            <span class="sub-badge">HIGH RESOLUTION GALLERY ({{ p.galleryImages.length }} PHOTOS)</span>
            <h2 class="section-heading">PROJECT PHOTOGRAPHY</h2>
          </div>

          <!-- Gallery View Mode Controls -->
          <div class="gallery-view-controls">
            <button 
              class="view-mode-btn" 
              [class.active]="galleryViewMode() === 'mosaic'" 
              (click)="setGalleryViewMode('mosaic')"
              title="Editorial Mosaic Grid">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
              <span>MOSAIC</span>
            </button>
            <button 
              class="view-mode-btn" 
              [class.active]="galleryViewMode() === 'grid'" 
              (click)="setGalleryViewMode('grid')"
              title="View All Photos">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18"/></svg>
              <span>ALL PHOTOS</span>
            </button>
          </div>
        </div>

        <!-- MODE 2: EDITORIAL MOSAIC MODE -->
        @if (galleryViewMode() === 'mosaic') {
          <div class="mosaic-container">
            <!-- Main Featured Photo (Left) -->
            @if (p.galleryImages[0]; as heroImg) {
              <div class="mosaic-hero-item" (click)="openImageLightbox(0)">
                <img [src]="heroImg" [alt]="p.title" (error)="onImgErr($event)">
                <div class="mosaic-overlay">
                  <span class="mosaic-badge">FEATURED RESIDENCE PHOTO</span>
                  <span class="view-tag">CLICK TO ENLARGE</span>
                </div>
              </div>
            }

            <!-- 4 Grid Accent Photos (Right) -->
            <div class="mosaic-side-grid">
              @for (img of p.galleryImages.slice(1, 5); track img; let i = $index) {
                <div class="mosaic-side-item" (click)="openImageLightbox(i + 1)">
                  <img [src]="img" [alt]="p.title" (error)="onImgErr($event)">
                  
                  <!-- 4th Item (+N More Overlay) -->
                  @if (i === 3 && p.galleryImages.length > 5) {
                    <div class="mosaic-more-overlay">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                      <span class="more-count">+{{ p.galleryImages.length - 5 }} MORE</span>
                      <span class="more-lbl">VIEW FULL GALLERY</span>
                    </div>
                  } @else {
                    <div class="mosaic-overlay">
                      <span class="view-tag">ENLARGE</span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- MODE 3: FULL PORTFOLIO GRID -->
        @if (galleryViewMode() === 'grid') {
          <div class="gallery-grid">
            @for (img of p.galleryImages; track img; let i = $index) {
              <div class="gallery-thumb-card" (click)="openImageLightbox(i)">
                <img [src]="img" [alt]="p.title" (error)="onImgErr($event)">
                <div class="thumb-hover-overlay">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                  <span>PHOTO 0{{ i + 1 }}</span>
                </div>
              </div>
            }
          </div>
        }
      </section>

      <!-- Bottom Consultation CTA Callout -->
      <div class="detail-bottom-cta">
        <h2 class="cta-heading font-serif">LOVE THIS ARCHITECTURAL STYLE?</h2>
        <p class="cta-sub">Let's discuss building your dream residence in Sydney.</p>
        <button (click)="requestConsultationForProject()" class="btn-gold">
          BOOK A CONSULTATION FOR THIS PROJECT
        </button>
      </div>

    </div>

    <!-- Interactive Image Lightbox Modal with Next / Previous Slider -->
    @if (lightboxIndex() >= 0 && p.galleryImages[lightboxIndex()]; as activeImg) {
      <div class="lightbox-backdrop" (click)="closeImageLightbox()">
        
        <!-- Lightbox Counter & Close Top Bar -->
        <div class="lightbox-top-bar" (click)="$event.stopPropagation()">
          <span class="photo-counter">IMAGE 0{{ lightboxIndex() + 1 }} / 0{{ p.galleryImages.length }}</span>
          <button class="close-btn" (click)="closeImageLightbox()" aria-label="Close Lightbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <!-- Previous Arrow Button -->
        @if (p.galleryImages.length > 1) {
          <button class="lightbox-arrow prev-arrow" (click)="prevImage($event)" aria-label="Previous Image">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
        }

        <div class="lightbox-inner" (click)="$event.stopPropagation()">
          <img [src]="activeImg" [alt]="p.title" (error)="onImgErr($event)" class="lightbox-img">
        </div>

        <!-- Next Arrow Button -->
        @if (p.galleryImages.length > 1) {
          <button class="lightbox-arrow next-arrow" (click)="nextImage($event)" aria-label="Next Image">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M9 18l6-6-6-6"/></svg>
          </button>
        }

      </div>
    }

  </article>
}
